import { createSlice } from '../wrappers';

const initialState = {
	tabIndex: 0,
	tabsCount: 0,
};

const vehicleTabsSlice = createSlice({
	name: 'vehicleTabs',
	initialState,
	reducers: {
		setTabIndex: (state, action) => {
			let nextTabIndex = action.payload;
			if (state.tabsCount === 0) {
				nextTabIndex = -1;
			} else if (nextTabIndex < 0) {
				nextTabIndex = state.tabsCount - 1;
			} else if (nextTabIndex > state.tabsCount - 1) {
				nextTabIndex = 0;
			}
			state.tabIndex = nextTabIndex;
		},
		setTabsCount: (state, action) => {
			state.tabsCount = action.payload;
		},
	},
});

export const { setTabIndex, setTabsCount } = vehicleTabsSlice.actions;

export default vehicleTabsSlice.reducer;
